module.exports = __webpack_public_path__ + "static/app_master-215a68c8f956250e50c9a850a04ed8ac.png";